export default __webpack_public_path__ + "static/media/om.e4ee63f3.png";